import React, { forwardRef, type TextareaHTMLAttributes } from "react";

import clsx from "clsx";
import { get } from "lodash";

interface TextAreaInputProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  onChange: (event: any) => void;

  name?: string;
  label?: string | React.ReactElement;
  value?: string;
  defaultValue?: string;
  onBlur?: (event: any) => void;
  className?: string;
  placeholder?: string;
  width?: string;
  maxWidth?: string;
  errorMessage?: string;
  errors?: any;
  isDisabled?: boolean;
  rows?: number;
  resizable?: boolean;
}

export const TextAreaInput = forwardRef<
  HTMLTextAreaElement,
  TextAreaInputProps
>(
  (
    {
      name,
      label,
      value,
      defaultValue,
      onChange,
      onBlur,
      className,
      placeholder,
      width,
      maxWidth,
      errorMessage,
      errors,
      isDisabled = false,
      rows = 4,
      resizable = false,
    },
    ref,
  ) => {
    // Access the error message from react-hook-form
    const formErrorMessage = get(errors, `${name}.message`);
    const hasError = errorMessage || formErrorMessage;

    return (
      <div
        className={clsx("nb-input-container", label && "has-label", className)}
        style={{ width, maxWidth }}
      >
        {label && <label className="label">{label}</label>}
        <textarea
          name={name}
          ref={ref}
          className={clsx("nb-input", {
            "h-[unset] resize-none": !resizable,
            "min-h-[6rem]": resizable,
          })}
          onBlur={onBlur}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          rows={rows}
        />
        {hasError && (
          <div className="error-message">
            {errorMessage ?? formErrorMessage}
          </div>
        )}
      </div>
    );
  },
);
